import React, { useCallback } from "react";
import { Modal, Table, Tag, Timeline, Spin } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const STATUS_COLORS = {
  "Invoice Created": "blue",
  "Payment Successful": "green",
  "Payment Failed": "red",
  "Link Expired": "orange",
  "Refunded": "purple",
  "Partially Refunded": "geekblue",
};

const columns = [
  {
    title: "Status",
    dataIndex: "current_status",
    key: "current_status",
    width: 160,
    render: (status) => (
      <Tag color={STATUS_COLORS[status] || "default"}>{status}</Tag>
    ),
  },
  {
    title: "Customer",
    dataIndex: "customer_name",
    key: "customer_name",
    width: 140,
  },
  {
    title: "Vehicle",
    key: "vehicle",
    width: 140,
    render: (_, record) => `${record.make || ""} ${record.model || ""}`.trim() || "—",
  },
  {
    title: "Part",
    dataIndex: "body_part",
    key: "body_part",
    width: 120,
  },
  {
    title: "Price (AED)",
    dataIndex: "price_given",
    key: "price_given",
    width: 110,
    render: (val) => val != null ? Number(val).toLocaleString("en-AE", { minimumFractionDigits: 2 }) : "—",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 110,
    render: (val) => val ? dayjs(val).format("DD MMM YYYY") : "—",
  },
  {
    title: "Provider",
    dataIndex: "provider",
    key: "provider",
    width: 100,
    render: (val) => val ? val.charAt(0).toUpperCase() + val.slice(1) : "—",
  },
];

const PaymentsHistoryModal = ({ open, onClose, payments, loading }) => {
  const expandedRowRender = useCallback((record) => {
    const items = (record.timeline || []).map((entry, idx) => ({
      key: idx,
      label: entry.timestamp ? dayjs(entry.timestamp).format("DD MMM YYYY HH:mm") : "",
      children: entry.status || entry.event || "—",
    }));
    return (
      <Timeline
        mode="left"
        items={items}
        style={{ marginTop: 8, marginBottom: 4 }}
      />
    );
  }, []);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <span>
          <DollarOutlined style={{ marginRight: 8, color: "#1d4ed8" }} />
          Payments History
        </span>
      }
      footer={null}
      width={900}
      style={{ top: 20 }}
      styles={{ body: { height: "calc(100vh - 190px)", overflowY: "auto" } }}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
          <Table
            dataSource={payments}
            columns={columns}
            rowKey="payment_id"
            size="small"
            expandable={{
              expandedRowRender,
              rowExpandable: (record) => Array.isArray(record.timeline) && record.timeline.length > 0,
            }}
            pagination={{ pageSize: 10, showSizeChanger: false }}
            locale={{ emptyText: "No payment records found." }}
          />
        </div>
      )}
    </Modal>
  );
};

export default PaymentsHistoryModal;
